module.exports = __webpack_public_path__ + "static/eco_icon-b111f0a0de86b445f3870de648558b73.svg";